import { JSX, PropsWithChildren, ReactElement } from 'react'
import { styled } from 'styled-components'

import { IconSize } from '../assets/Icons'
import { SPACE_XXXSMALL } from '../global/spacing'
import { TertiaryHeading } from '../typography/headings/TertiaryHeading'
import { getShortRequestId } from '../utilities/helpers'
import { TightSectionContent } from './TightSectionContent'

const ModalContainer = styled(TightSectionContent)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  > * {
    width: 100%;
  }
`

const IconContainer = styled.div`
  width: ${IconSize.MEDIUM}px;
  height: ${IconSize.MEDIUM}px;
  margin-bottom: ${SPACE_XXXSMALL};
`

const ModalContentContainer = styled.div`
  flex: 1 0 0;
`

export interface ModalContentProps {
  icon?: JSX.Element
  header?: ReactElement | string
  headerAdditionalText?: string
  requestId?: string
}

export const ModalContent = ({
  icon,
  header,
  headerAdditionalText,
  children,
  requestId,
}: PropsWithChildren<ModalContentProps>) => {
  const shortRequestId = requestId && getShortRequestId(requestId)

  const additionalText = shortRequestId ?? headerAdditionalText

  const headerElement =
    typeof header === 'string' ? (
      <TertiaryHeading header={header} additionalText={additionalText} tagName="h2" />
    ) : (
      header
    )

  return (
    <ModalContainer>
      {(icon || header) && (
        <div>
          {icon && <IconContainer aria-hidden={true}>{icon}</IconContainer>}
          {header && headerElement}
        </div>
      )}
      <ModalContentContainer>{children}</ModalContentContainer>
    </ModalContainer>
  )
}
